<template>
  <div>
    <div class="row divAddPlan">
      <div v-if="optionSelected.name==respuesta_afirmativa && (subtipo !==subtipo_libre && subtipo !== subtipo_declaracion)" class="divInfo col-8">
        <span v-if="!isManual">*Campo obligatorio: introducir al menos un instrumento o plan existente
        para poder guardar cambios.</span>
      </div>
      <div v-if="optionSelected.name==respuesta_negativa" class="divInfo col-8">
        <span v-if="!isManual">*Campos obligatorios.</span>
      </div>
      <div v-if="optionSelected.name==respuesta_afirmativa && (subtipo !==subtipo_libre && subtipo !== subtipo_declaracion)" class="col-4">
        <q-btn
          unelevated
          class="bSecondary rigth"
          label="AÑADIR INSTRUMENTO/PLAN"
          icon="add"
          @click="triggerAdd()"
          :style="isOnlyAccess? 'display:none': ''"
        />
      </div>
    </div>
    <div v-if="optionSelected.name==respuesta_afirmativa && (subtipo !==subtipo_libre && subtipo !== subtipo_declaracion)">
      <ListadoInstrumentoPlan :isLoading="isLoading" :planes="planes" title="Instrumentos/planes existentes" />
    </div>
    <div v-if="optionSelected.name==respuesta_afirmativa && subtipo == subtipo_declaracion">
      <div class="row">
        <!--subir declaración-->
        <div class="col-12">
          <Upload
            class="rigth"
            label="AÑADIR DECLARACIÓN"
            v-model="fileDeclaracion"
          />
        </div>
      </div>
      <ListadoDeclaracion :isLoading="isLoading" :declaraciones="declaraciones" />

    </div>
    <div class="row">
      <div class="col-12">
        <q-input
          v-model="observaciones"
          type="textarea"
          label="Observaciones"
          outlined
          @input="edited()"
          :readonly="isOnlyAccess"
        ></q-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <q-input
          v-model="indicadoresAsociados"
          type="textarea"
          label="Indicadores complementarios no pertenecientes a AUE"
          outlined
          @input="edited()"
          :readonly="isOnlyAccess"
        ></q-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <q-input
          v-model="compromisos"
          :class="optionSelected.name==respuesta_negativa? 'required': ''"
          type="textarea"
          label="Compromisos"
          outlined
          @input="edited()"
          :readonly="isOnlyAccess"
        ></q-input>
      </div>
    </div>

    <PopUpInstrumentoPlan v-model="showPopUpAddInstrumento" />
  </div>
</template>
<script>
import ListadoInstrumentoPlan from '@/components/PlanAccion/components/ListadoInstrumentoPlan.vue';
import ListadoDeclaracion from '@/components/PlanAccion/components/ListadoDeclaracion.vue';
import PopUpInstrumentoPlan from '@/components/PlanAccion/components/PopUpInstrumentoPlan.vue';
import Const from '@/components/shared/helpers/Const.js';
import Upload from '@/shared/upload/components/Upload.vue';
import Message from '@/components/shared/mixins/Message.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    ListadoInstrumentoPlan,
    PopUpInstrumentoPlan,
    Upload,
    ListadoDeclaracion
  },
  mixins: [Message],
  computed: {
    ...mapGetters({
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  props: {
    instrumentoPlan: Object,
    isLoading: Boolean,
    optionSelected: Object,
    isManual: Boolean,
    subtipo: {
      type: String,
      default: () => Const.SUBTIPO_DEFECTO
    }
  },
  created () {
    this.fillData();
  },
  watch: {
    instrumentoPlan () {
      this.fillData();
    },
    fileDeclaracion: {
      handler: function () {
        if (this.fileDeclaracion != null) {
          let declaracion = {
            nombre: this.fileDeclaracion.name,
            fechaSubida: this.fileDeclaracion.lastModifiedDate
          };
          if (this.declaraciones.length + 1 <= 10) {
            let repe = false;
            this.declaraciones.forEach(dec => {
              if (dec.nombre === declaracion.nombre) {
                repe = true;
              }
            });
            if (repe === false) {
              this.declaraciones.push(declaracion);
              this.$emit('updateArrayFiles', this.fileDeclaracion);
            }
          } else {
            this.showError('No se pueden añadir más de 10 declaraciones');
          }
        }
      },
      deep: true
    }
  },
  data () {
    return {
      observaciones: '',
      indicadoresAsociados: '',
      compromisos: '',
      planes: [],
      declaraciones: [],
      showPopUpAddInstrumento: false,
      subtipo_defecto: Const.SUBTIPO_DEFECTO,
      subtipo_libre: Const.SUBTIPO_LIBRE,
      respuesta_afirmativa: Const.RESPUESTA_AFIRMATIVA,
      respuesta_negativa: Const.RESPUESTA_NEGATIVA,
      subtipo_declaracion: Const.SUBTIPO_SUBIR_DECLARACION,
      fileDeclaracion: null
    };
  },
  methods: {
    triggerAdd () {
      this.showPopUpAddInstrumento = true;
    },
    fillData () {
      if (this.instrumentoPlan) {
        this.planes = this.instrumentoPlan.planes;
        this.observaciones = this.instrumentoPlan.observaciones;
        this.compromisos = this.instrumentoPlan.compromisos;
        this.indicadoresAsociados = this.instrumentoPlan.indicadoresAsociados;
        if (this.instrumentoPlan.hasOwnProperty('listadoDeDeclaraciones')) this.declaraciones = this.instrumentoPlan.listadoDeDeclaraciones;
      }
    },
    edited () {
      let dataIndicador = {
        planes: this.planes,
        observaciones: this.observaciones,
        compromisos: this.compromisos,
        indicadoresAsociados: this.indicadoresAsociados
      };
      if (this.instrumentoPlan.hasOwnProperty('listadoDeDeclaraciones')) {
        dataIndicador['listadoDeDeclaraciones'] = this.declaraciones;
      }
      this.$emit('updateDataIndicador', dataIndicador);
    }
  }
};
</script>

<style scoped>
.row {
  margin-top: 15px;
}
.divInfo {
  margin: 15px 0px 1px 0px;
  font-family: DINPro;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.09px;
  color: #555;
}
.divAddPlan {
  margin-bottom: 15px;
}
.rigth {
  float: right;
}
</style>
